import {LABEL_TRANSLATION_PREFIX} from './label-translation-prefix.model';
import {LabelTranslator} from './label-translator.model';

/**
 * Remplace, partout dans une structure, les clés de traduction par leur texte.
 *
 * Un modèle d'enquête livre ses libellés — titres, descriptions, choix, critères, bornes, message
 * d'obligation — sous forme de clés, à charge pour la vue de les traduire. Le brouillon les
 * renverrait telles quelles au serveur, qui n'aurait alors du questionnaire qu'une suite de clés :
 * illisible dans un export, et impossible à retraduire une fois sorti de l'application.
 *
 * Le parcours est aveugle au champ traversé, et c'est voulu : un élément conserve tout ce qu'il
 * reçoit dans son index de secours, et les libellés que l'éditeur ne modélise pas encore y
 * repartiraient en clés. Il n'opère que sur la forme plate (`JSON`), jamais sur les classes du
 * domaine : les méthodes de prototype n'y survivraient pas.
 *
 * Seules les chaînes préfixées comme une clé sont soumises à la traduction, et une clé inconnue
 * revient inchangée : un texte que l'utilisateur a écrit lui-même traverse sans être touché.
 */
export const resolveLabelKeys = <T>(value: T, translate: LabelTranslator): T => {
    if (typeof value === 'string') {
        return (value.startsWith(LABEL_TRANSLATION_PREFIX) ? translate(value) : value) as T;
    }

    if (Array.isArray(value)) {
        return value.map((item: unknown) => resolveLabelKeys(item, translate)) as T;
    }

    if (value !== null && typeof value === 'object') {
        return Object.fromEntries(
            Object.entries(value).map(([field, fieldValue]) => [field, resolveLabelKeys(fieldValue, translate)])
        ) as T;
    }

    return value;
};
